import createReducer from '../../utils/createReducer';

const initialState = {};

export default createReducer(initialState, {});
